import React from 'react';
import {
  Container,
  Heading,
  Text,
  SimpleGrid,
  Box,
  VStack,
  Icon
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { LuCalendarDays, LuVideo, LuImage } from 'react-icons/lu';

export default function AdminLanding() {
  const adminCards = [
    {
      title: 'Manage Events',
      description:
        'Create, edit, and delete photography events and client galleries.',
      icon: LuCalendarDays,
      path: '/admin/manage-events',
      color: 'orange.500'
    },
    {
      title: 'Manage Videos',
      description:
        'Update your video portfolio, reorder clips, and manage descriptions.',
      icon: LuVideo,
      path: '/admin/manage-videos',
      color: 'purple.500'
    },
    {
      title: 'Manage Images',
      description:
        'Configure category images, manage hero shots, and image sets.',
      icon: LuImage,
      path: '/admin/manage-images',
      color: 'blue.500'
    }
  ];

  return (
    <Container p={8} maxW="container.lg">
      <Box mb={10} textAlign="center">
        <Heading size="2xl" mb={4} fontWeight="extrabold">
          Admin Dashboard
        </Heading>
        <Text fontSize="lg" color="gray.500" _dark={{ color: 'gray.400' }}>
          Welcome back! Select a module to update your website content.
        </Text>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 3 }} gap={8}>
        {adminCards.map((card) => (
          <Box
            key={card.path}
            as={RouterLink}
            to={card.path}
            p={8}
            borderWidth="1px"
            borderRadius="2xl"
            bg="white"
            _dark={{ bg: 'gray.800', borderColor: 'gray.700' }}
            boxShadow="sm"
            transition="all 0.3s ease"
            _hover={{
              transform: 'translateY(-8px)',
              boxShadow: '2xl',
              borderColor: card.color
            }}
            position="relative"
            overflow="hidden"
          >
            {/* Subtle background glow on hover */}
            <Box
              position="absolute"
              top="-20%"
              right="-20%"
              w="150px"
              h="150px"
              bg={card.color}
              filter="blur(50px)"
              opacity="0.05"
              transition="opacity 0.3s"
              _groupHover={{ opacity: 0.15 }}
            />

            <VStack align="flex-start" gap={4}>
              <Box
                p={3}
                borderRadius="xl"
                bg={`${card.color.split('.')[0]}.50`}
                color={card.color}
                _dark={{ bg: `${card.color.split('.')[0]}.900`, opacity: 0.8 }}
              >
                <Icon as={card.icon} boxSize={8} />
              </Box>
              <Box>
                <Heading size="md" mb={2}>
                  {card.title}
                </Heading>
                <Text
                  fontSize="sm"
                  color="gray.600"
                  _dark={{ color: 'gray.400' }}
                  lineHeight="tall"
                >
                  {card.description}
                </Text>
              </Box>
            </VStack>
          </Box>
        ))}
      </SimpleGrid>
    </Container>
  );
}
